import { Typography, Button, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./index.less";

const { Paragraph } = Typography;

const HomePageBecomeCreatorSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Row className="become-creator_main" justify="center">
      <div className="become-creator-container">
        <div className="become-creator-header">
          <div className="become-creator-title">{t("become-creator")} ?</div>
          <Paragraph className="become-creator-subtitle">{t("monetize-your-content-best-way-text")}</Paragraph>
          <Button className="become-creator-button" type="primary" onClick={() => navigate("/auth/signUp?currentTab=creator")}>
            {t("become-creator")}
          </Button>
        </div>
      </div>
    </Row>
  );
};

export default HomePageBecomeCreatorSection;
